/**
 * Format a monetary amount for display in Argentine Spanish locale.
 */
export function formatCurrency(amount, options = {}) {
    const maximumFractionDigits = options.maximumFractionDigits ?? 2;
    const minimumFractionDigits = options.minimumFractionDigits ?? maximumFractionDigits;

    const numeric = parseFloat(amount);
    const value = Number.isNaN(numeric) ? 0 : numeric;

    return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        maximumFractionDigits,
        minimumFractionDigits,
    }).format(value);
}
